<template>
  <v-row>
    <!-- Dialogs e Snackbars (mantidos iguais) -->
    <v-dialog v-model="dialogErro.status" persistent max-width="500">
      <CardDialog :dialog="dialogErro" />
    </v-dialog>

    <v-dialog v-model="dialog" persistent max-width="400">
      <v-card color="primary" dark>
        <v-card-text class="pa-6">
          <div class="text-center">
            <v-progress-circular
                indeterminate
                color="white"
                size="50"
                width="5"
                class="mb-4"
            ></v-progress-circular>
            <div class="text-h6 mb-2">Processando arquivo</div>
            <div class="text-body-2">Aguarde, estamos gerando seu relatório...</div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-snackbar
        v-model="snackbar.status"
        :timeout="snackbar.timeout"
        color="warning"
        top
        centered
    >
      <div class="d-flex align-center">
        <v-icon class="mr-2">mdi-alert-circle</v-icon>
        <span>Nenhum arquivo a ser gerado para o filtro informado.</span>
      </div>
      <template v-slot:action="{ attrs }">
        <v-btn icon small v-bind="attrs" @click="snackbar.status = false">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <v-snackbar
        v-model="snackbarSucesso.status"
        :timeout="snackbarSucesso.timeout"
        color="success"
        top
        centered
    >
      <div class="d-flex align-center">
        <v-icon class="mr-2">mdi-check-circle</v-icon>
        <span>{{ snackbarSucesso.message }}</span>
      </div>
      <template v-slot:action="{ attrs }">
        <v-btn icon small v-bind="attrs" @click="snackbarSucesso.status = false">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <v-snackbar
        v-model="snackbarErro.status"
        :timeout="snackbarErro.timeout"
        color="error"
        top
        centered
    >
      <div class="d-flex align-center">
        <v-icon class="mr-2">mdi-alert-circle</v-icon>
        <span>{{ snackbarErro.message }}</span>
      </div>
      <template v-slot:action="{ attrs }">
        <v-btn icon small v-bind="attrs" @click="snackbarErro.status = false">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <!-- Filtros (mantidos iguais) -->
    <v-col cols="12">
      <v-card elevation="2">
        <v-card-title>
          <v-icon class="mr-2">mdi-filter-variant</v-icon>
          Filtros de Exportação
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pb-0 mb-3">
          <v-form ref="form">
            <v-row>
              <v-col cols="12" md="12" lg="4">
                <v-autocomplete
                    :items="filiaisFiltro"
                    clearable
                    item-text="filial"
                    item-value="idfilial"
                    label="Selecione as Filiais"
                    outlined
                    dense
                    hide-details="auto"
                    :disabled="dialog"
                    v-model="busca.idfiliais"
                    multiple
                    chips
                    small-chips
                    deletable-chips
                    :rules="[v => (v && v.length > 0) || 'Selecione ao menos uma filial']"
                    prepend-inner-icon="mdi-domain"
                >
                  <template v-slot:prepend-item>
                    <v-list-item ripple @click="toggleTodasFiliais">
                      <v-list-item-action>
                        <v-icon :color="todasFiliaisSelecionadas ? 'primary' : ''">
                          {{ iconTodasFiliais }}
                        </v-icon>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ todasFiliaisSelecionadas ? 'Desmarcar Todas' : 'Selecionar Todas' }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider class="mt-2"></v-divider>
                  </template>
                  <template v-slot:selection="{ item, index }">
                    <v-chip
                        v-if="index < 1"
                        small
                        @click:close="removeFilial(item)"
                    >
                      {{ item.filial }}
                    </v-chip>
                    <span
                        v-if="index === 1"
                        class="grey--text text-caption ml-1"
                    >(+{{ busca.idfiliais.length - 1 }} outras)</span>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="12" md="12" lg="4" class="pl-3 pl-lg-0">
                <v-autocomplete
                    :items="tiposComissao"
                    clearable
                    item-text="texto"
                    item-value="valor"
                    label="Tipos de Comissão"
                    outlined
                    dense
                    hide-details="auto"
                    :disabled="dialog"
                    v-model="busca.tiposComissao"
                    multiple
                    chips
                    small-chips
                    deletable-chips
                    :rules="[v => (v && v.length > 0) || 'Selecione ao menos um tipo de comissão']"
                    prepend-inner-icon="mdi-cash-multiple"
                >
                  <template v-slot:prepend-item>
                    <v-list-item ripple @click="toggleTodosTipos">
                      <v-list-item-action>
                        <v-icon :color="todosTiposSelecionados ? 'primary' : ''">
                          {{ iconTodosTipos }}
                        </v-icon>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ todosTiposSelecionados ? 'Desmarcar Todos' : 'Selecionar Todos' }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider class="mt-2"></v-divider>
                  </template>

                  <template v-slot:selection="{ item, index }">
                    <v-chip
                        v-if="index < 1"
                        small
                        @click:close="removeTipo(item)"
                    >
                      {{ item.texto }}
                    </v-chip>
                    <span
                        v-if="index === 1"
                        class="grey--text text-caption ml-1"
                    >(+{{ busca.tiposComissao.length - 1 }} outros)</span>
                  </template>

                  <template v-slot:item="{ item }">
                    <v-list-item-icon>
                      <v-icon class="mt-4" color="primary">{{ item.icone }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>{{ item.texto }}</v-list-item-title>
                      <v-list-item-subtitle class="text-caption">
                        {{ item.descricao }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="12" md="12" lg="4" class="pl-3 pl-lg-0">
                <v-row no-gutters>
                  <v-col cols="12" sm="8" class="pr-0 pr-sm-3 pb-3 pb-sm-3">
                    <InputDatePicker
                        :disabled="dialog"
                        v-model="busca.dtmes"
                        label="Mês de Referência"
                        :outlined="true"
                        :dense="true"
                        type="mounth"
                    />
                  </v-col>
                  <v-col cols="12" sm="4">
                    <v-btn
                        :loading="dialog"
                        :disabled="dialog || busca.idfiliais.length === 0"
                        block
                        height="40"
                        color="primary"
                        elevation="2"
                        @click="gerarArquivo()"
                    >
                      <v-icon class="mr-2">mdi-file-download</v-icon>
                      <span>Gerar</span>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-col>

    <!-- Tabelas com Abas -->
    <v-col cols="12">
      <v-card elevation="2" :loading="dialog">
        <!-- Estado de Loading -->
        <v-card-text v-if="dialog" class="text-center py-12">
          <v-progress-circular
              indeterminate
              color="primary"
              size="64"
              width="6"
          ></v-progress-circular>
          <div class="text-h6 mt-4 grey--text">Carregando dados...</div>
        </v-card-text>

        <!-- Conteúdo com Abas -->
        <template v-else-if="temDados">
          <v-tabs v-model="abaAtiva" background-color="primary" dark slider-color="yellow">
            <v-tab v-if="dadosVendedores.length > 0">
              <v-icon class="mr-2">mdi-account-cash</v-icon>
              Vendedores
              <v-chip small class="ml-2" color="white" text-color="primary">
                {{ dadosVendedores.length }}
              </v-chip>
            </v-tab>
            <v-tab v-if="dadosConvenios.length > 0">
              <v-icon class="mr-2">mdi-handshake</v-icon>
              Convênios
              <v-chip small class="ml-2" color="white" text-color="primary">
                {{ dadosConvenios.length }}
              </v-chip>
            </v-tab>
            <v-tab v-if="dadosMotoristas.length > 0">
              <v-icon class="mr-2">mdi-truck-fast</v-icon>
              Motoristas
              <v-chip small class="ml-2" color="white" text-color="primary">
                {{ dadosMotoristas.length }}
              </v-chip>
            </v-tab>
          </v-tabs>

          <v-tabs-items v-model="abaAtiva">
            <!-- ABA: VENDEDORES -->
            <v-tab-item v-if="dadosVendedores.length > 0">
              <v-card flat>
                <v-card-title>
                  <v-icon class="mr-2">mdi-table</v-icon>
                  {{ tituloTabelaVendedores }}
                  <v-spacer />
                  <ExcelExporter
                      :dados="dadosVendedores"
                      :bonificacoes="bonificacoesVendedores"
                      :filename="`vendedores_${busca.dtmes.replace('-', '_')}`"
                      label="Exportar Excel"
                      tipo="vendedores"
                      :mostrar-comissao-base="mostrarComissaoBase"
                      @success="handleExportSuccess"
                      @error="handleExportError"
                      small
                  />
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pa-0">
                  <div style="overflow-x: auto;">
                    <v-simple-table dense>
                      <thead>
                      <tr>
                        <th class="text-left">Filial</th>
                        <th class="text-left">Vendedor</th>
                        <!-- Colunas condicionais de comissão base -->
                        <th v-if="mostrarComissaoBase" class="text-right">Meta</th>
                        <th v-if="mostrarComissaoBase" class="text-right">Venda Base</th>
                        <th v-if="mostrarComissaoBase" class="text-right">Comissão Base</th>
                        <!-- Colunas dinâmicas para bonificações -->
                        <template v-for="bonif in bonificacoesVendedores">
                          <th :key="`venda-${bonif}`" class="text-right">
                            <div class="d-flex align-center justify-end">
                              <span>Venda {{ bonif }}</span>
                              <v-tooltip bottom max-width="350" color="primary">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon small class="ml-1" v-bind="attrs" v-on="on">
                                    mdi-information-outline
                                  </v-icon>
                                </template>
                                <div class="pa-2">
                                  <div class="font-weight-bold text-subtitle-1 mb-2">
                                    {{ getBonificacaoInfo(bonif).nome }}
                                  </div>
                                  <v-divider class="my-2" dark></v-divider>
                                  <div class="d-flex justify-space-between mb-1">
                                    <span class="text-caption">Código:</span>
                                    <span class="text-caption font-weight-bold">{{ bonif }}</span>
                                  </div>
                                  <div class="d-flex justify-space-between mb-1">
                                    <span class="text-caption">Percentual:</span>
                                    <span class="text-caption font-weight-bold">
                                      {{ (getBonificacaoInfo(bonif).percentual * 100).toFixed(2) }}%
                                    </span>
                                  </div>
                                  <div class="d-flex justify-space-between">
                                    <span class="text-caption">Evento Senior:</span>
                                    <span class="text-caption font-weight-bold">
                                      {{ getBonificacaoInfo(bonif).eventosenior }}
                                    </span>
                                  </div>
                                </div>
                              </v-tooltip>
                            </div>
                          </th>
                          <th :key="`comissao-${bonif}`" class="text-right">Comissão {{ bonif }}</th>
                        </template>
                        <th v-if="mostrarComissaoBase" class="text-right">Salário Total</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(u, i) in dadosVendedores" :key="i" :class="i % 2 === 0 ? 'grey lighten-5' : ''">
                        <td>{{ u.idfilial }}</td>
                        <td class="text-truncate font-weight-medium" style="max-width: 200px;">
                          {{ u.vendedor }}
                        </td>
                        <td v-if="mostrarComissaoBase" class="text-right">{{ u.meta | formataDinheiro }}</td>
                        <td v-if="mostrarComissaoBase" class="text-right">{{ u.vendabase | formataDinheiro }}</td>
                        <td v-if="mostrarComissaoBase" class="text-right font-weight-medium">{{ u.comissaobase | formataDinheiro }}</td>
                        <template v-for="bonif in bonificacoesVendedores">
                          <td :key="`venda-${bonif}-${i}`" class="text-right">
                            <span :class="getBonificacaoVenda(u, bonif) > 0 ? 'success--text font-weight-medium' : ''">
                              {{ getBonificacaoVenda(u, bonif) | formataDinheiro }}
                            </span>
                          </td>
                          <td :key="`comissao-${bonif}-${i}`" class="text-right">
                            <span :class="getBonificacaoComissao(u, bonif) > 0 ? 'success--text font-weight-medium' : ''">
                              {{ getBonificacaoComissao(u, bonif) | formataDinheiro }}
                            </span>
                          </td>
                        </template>
                        <td v-if="mostrarComissaoBase" class="text-right font-weight-bold primary--text">
                          {{ u.salario | formataDinheiro }}
                        </td>
                      </tr>
                      </tbody>
                      <tfoot>
                      <tr class="primary white--text">
                        <td colspan="2" class="font-weight-bold">TOTAL GERAL</td>
                        <td v-if="mostrarComissaoBase" class="text-right font-weight-bold">{{ somarCampo(dadosVendedores, 'meta') | formataDinheiro }}</td>
                        <td v-if="mostrarComissaoBase" class="text-right font-weight-bold">{{ somarCampo(dadosVendedores, 'vendabase') | formataDinheiro }}</td>
                        <td v-if="mostrarComissaoBase" class="text-right font-weight-bold">{{ somarCampo(dadosVendedores, 'comissaobase') | formataDinheiro }}</td>
                        <template v-for="bonif in bonificacoesVendedores">
                          <td :key="`total-venda-${bonif}`" class="text-right font-weight-bold">
                            {{ somarBonificacaoVenda(dadosVendedores, bonif) | formataDinheiro }}
                          </td>
                          <td :key="`total-comissao-${bonif}`" class="text-right font-weight-bold">
                            {{ somarBonificacaoComissao(dadosVendedores, bonif) | formataDinheiro }}
                          </td>
                        </template>
                        <td v-if="mostrarComissaoBase" class="text-right font-weight-bold">{{ somarCampo(dadosVendedores, 'salario') | formataDinheiro }}</td>
                      </tr>
                      </tfoot>
                    </v-simple-table>
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>

            <!-- ABA: CONVÊNIOS -->
            <v-tab-item v-if="dadosConvenios.length > 0">
              <v-card flat>
                <v-card-title>
                  <v-icon class="mr-2">mdi-table</v-icon>
                  Comissões de Convênios
                  <v-spacer />
                  <ExcelExporter
                      :dados="dadosConvenios"
                      :filename="`convenios_${busca.dtmes.replace('-', '_')}`"
                      label="Exportar Excel"
                      tipo="convenios"
                      @success="handleExportSuccess"
                      @error="handleExportError"
                      small
                  />
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pa-0">
                  <div style="overflow-x: auto;">
                    <v-simple-table dense>
                      <thead>
                      <tr>
                        <th class="text-left">Filial</th>
                        <th class="text-left">Vendedor</th>
                        <th class="text-right">Total Notas</th>
                        <th class="text-right">Comissão</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(u, i) in dadosConvenios" :key="i" :class="i % 2 === 0 ? 'grey lighten-5' : ''">
                        <td>{{ u.idfilial }}</td>
                        <td class="text-truncate font-weight-medium" style="max-width: 200px;">
                          {{ u.vendedor }}
                        </td>
                        <td class="text-right">{{ u.qtd_notas || 0 }}</td>
                        <td class="text-right font-weight-bold primary--text">
                          {{ u.salario | formataDinheiro }}
                        </td>
                      </tr>
                      </tbody>
                      <tfoot>
                      <tr class="primary white--text">
                        <td colspan="2" class="font-weight-bold">TOTAL GERAL</td>
                        <td class="text-right font-weight-bold">{{ somarCampo(dadosConvenios, 'qtd_notas') }}</td>
                        <td class="text-right font-weight-bold">{{ somarCampo(dadosConvenios, 'salario') | formataDinheiro }}</td>
                      </tr>
                      </tfoot>
                    </v-simple-table>
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>

            <!-- ABA: MOTORISTAS -->
            <v-tab-item v-if="dadosMotoristas.length > 0">
              <v-card flat>
                <v-card-title>
                  <v-icon class="mr-2">mdi-table</v-icon>
                  Bonificações de Motoristas
                  <v-spacer />
                  <ExcelExporter
                      :dados="dadosMotoristas"
                      :filename="`motoristas_${busca.dtmes.replace('-', '_')}`"
                      label="Exportar Excel"
                      tipo="motoristas"
                      @success="handleExportSuccess"
                      @error="handleExportError"
                      small
                  />
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pa-0">
                  <div style="overflow-x: auto;">
                    <v-simple-table dense>
                      <thead>
                      <tr>
                        <th class="text-left">Filial</th>
                        <th class="text-left">Motorista</th>
                        <th class="text-center">Meta Entregas</th>
                        <th class="text-center">Qtd Entregas</th>
                        <th class="text-right">Valor/Entrega</th>
                        <th class="text-right">Bonificação</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(u, i) in dadosMotoristas" :key="i" :class="i % 2 === 0 ? 'grey lighten-5' : ''">
                        <td>{{ u.idfilial }}</td>
                        <td class="text-truncate font-weight-medium" style="max-width: 200px;">
                          {{ u.vendedor }}
                        </td>
                        <td class="text-center">{{ u.meta_entregas || 0 }}</td>
                        <td class="text-center">
                          <v-chip
                              small
                              :color="u.qtd_entregas >= u.meta_entregas ? 'success' : 'warning'"
                              text-color="white"
                          >
                            {{ u.qtd_entregas || 0 }}
                          </v-chip>
                        </td>
                        <td class="text-right">{{ u.valor_por_entrega | formataDinheiro }}</td>
                        <td class="text-right font-weight-bold primary--text">
                          {{ u.valor_bonificacao | formataDinheiro }}
                        </td>
                      </tr>
                      </tbody>
                      <tfoot>
                      <tr class="primary white--text">
                        <td colspan="2" class="font-weight-bold">TOTAL GERAL</td>
                        <td class="text-center font-weight-bold">{{ somarCampo(dadosMotoristas, 'meta_entregas') }}</td>
                        <td class="text-center font-weight-bold">{{ somarCampo(dadosMotoristas, 'qtd_entregas') }}</td>
                        <td class="text-right font-weight-bold">-</td>
                        <td class="text-right font-weight-bold">{{ somarCampo(dadosMotoristas, 'valor_bonificacao') | formataDinheiro }}</td>
                      </tr>
                      </tfoot>
                    </v-simple-table>
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </template>

        <!-- Estado Vazio -->
        <v-card-text v-else class="text-center py-12">
          <v-icon color="grey lighten-1" size="120">mdi-folder-download-outline</v-icon>
          <div class="text-h6 mt-6 mb-2 grey--text text--darken-1">
            Nenhum dado para exibir
          </div>
          <div class="text-body-2 grey--text mb-4" style="max-width: 500px; margin: 0 auto;">
            Selecione as filiais, tipos de comissão e o mês no filtro acima, clique em "Gerar" e aguarde
            o processamento para visualizar os resultados.
          </div>
          <v-alert
              border="left"
              colored-border
              color="primary"
              elevation="1"
              outlined
              class="mx-auto mt-8"
              style="max-width: 600px;"
          >
            <div class="text-caption">
              <v-icon small color="primary" class="mr-1">mdi-information</v-icon>
              <strong>Importante:</strong> Os vendedores devem ter suas metas lançadas
              para serem exportados. Caso um vendedor não apareça, verifique se a meta foi cadastrada.
            </div>
          </v-alert>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapState } from "vuex";
import axios from "axios";
import mixinFilial from "../../util/mixinFilial";
import InputDatePicker from "../Widgets/InputDatePicker";
import CardDialog from "../Widgets/CardDialog";
import ExcelExporter from "./Widgets/ExcelExporter";

export default {
  name: "DepartamentoPessoalExportadorSenior",
  mixins: [mixinFilial],
  components: { InputDatePicker, CardDialog, ExcelExporter },
  data: () => ({
    aviso: false,
    snackbar: { status: false, timeout: 4000 },
    snackbarSucesso: { status: false, timeout: 3000, message: '' },
    snackbarErro: { status: false, timeout: 4000, message: '' },
    dialog: false,
    dialogErro: {
      status: false,
      title: "",
      msg: "",
      icon: "",
      iconColor: "",
    },
    abaAtiva: 0,
    dados: [],
    busca: {
      dtmes: `${new Date().getFullYear()}-${
          (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).getMonth() + 1 < 10 ? "0" : "") +
          (new Date().getMonth() + 1)
      }`,
      idfiliais: [],
      tiposComissao: ['comissao_vendedores', 'bonificacao_vendedores', 'convenios', 'bonificacao_motoristas'],
    },
    tiposComissao: [
      {
        valor: 'comissao_vendedores',
        texto: 'Comissão de Vendedores',
        descricao: 'Comissão baseada em vendas realizadas',
        icone: 'mdi-account-cash',
      },
      {
        valor: 'bonificacao_vendedores',
        texto: 'Bonificação Vendedores',
        descricao: 'Bonificações extras para vendedores',
        icone: 'mdi-gift',
      },
      {
        valor: 'convenios',
        texto: 'Convênios',
        descricao: 'Comissões por vendas de convênios',
        icone: 'mdi-handshake',
      },
      {
        valor: 'bonificacao_motoristas',
        texto: 'Bonificação Motoristas',
        descricao: 'Bonificações para motoristas e ajudantes',
        icone: 'mdi-truck-fast',
      }
    ],
    carregando: false,
  }),
  computed: {
    ...mapState(["backendUrl"]),
    filiaisFiltro() {
      if (this.filiais.lista) {
        return this.filiais.lista.filter((v) => {
          return v.idfilial !== 22 && v.idfilial !== 32 && v.idfilial !== 34;
        });
      } else {
        return [];
      }
    },
    // Separa dados por tipo
    dadosVendedores() {
      // Inclui dados com comissão base OU bonificações
      return this.dados.filter(d =>
          d.meta !== undefined ||
          d.vendabase !== undefined ||
          d.comissaobase !== undefined ||
          (d.bonificacoes && Object.keys(d.bonificacoes).length > 0)
      );
    },
    dadosConvenios() {
      return this.dados.filter(d => d.qtd_notas !== undefined);
    },
    dadosMotoristas() {
      return this.dados.filter(d => d.meta_entregas !== undefined);
    },
    temDados() {
      return this.dados.length > 0;
    },
    // Verifica se deve mostrar colunas de comissão base
    mostrarComissaoBase() {
      // Mostra se tiver comissao_vendedores selecionado
      return this.busca.tiposComissao.includes('comissao_vendedores');
    },
    // Título dinâmico da aba
    tituloAbaVendedores() {
      if (this.mostrarComissaoBase) {
        return 'Vendedores';
      }
      return 'Bonificações';
    },
    // Título dinâmico da tabela
    tituloTabelaVendedores() {
      if (this.mostrarComissaoBase) {
        return 'Comissões de Vendedores';
      }
      return 'Bonificações de Vendedores';
    },
    // Bonificações apenas para vendedores
    bonificacoesVendedores() {
      if (this.dadosVendedores.length === 0) return [];
      const bonificacoes = new Set();
      this.dadosVendedores.forEach((vendedor) => {
        if (vendedor.bonificacoes) {
          Object.keys(vendedor.bonificacoes).forEach((codigo) => {
            bonificacoes.add(codigo);
          });
        }
      });
      return Array.from(bonificacoes).sort();
    },
    todosTiposSelecionados() {
      return this.busca.tiposComissao.length === this.tiposComissao.length;
    },
    algumTipoSelecionado() {
      return this.busca.tiposComissao.length > 0 && !this.todosTiposSelecionados;
    },
    iconTodosTipos() {
      if (this.todosTiposSelecionados) return 'mdi-close-box';
      if (this.algumTipoSelecionado) return 'mdi-minus-box';
      return 'mdi-checkbox-blank-outline';
    },
    todasFiliaisSelecionadas() {
      return this.busca.idfiliais.length === this.filiaisFiltro.length;
    },
    algumaFiliaisSelecionada() {
      return this.busca.idfiliais.length > 0 && !this.todasFiliaisSelecionadas;
    },
    iconTodasFiliais() {
      if (this.todasFiliaisSelecionadas) return 'mdi-close-box';
      if (this.algumaFiliaisSelecionada) return 'mdi-minus-box';
      return 'mdi-checkbox-blank-outline';
    }
  },
  methods: {
    toggleTodosTipos() {
      this.$nextTick(() => {
        if (this.todosTiposSelecionados) {
          this.busca.tiposComissao = [];
        } else {
          this.busca.tiposComissao = this.tiposComissao.map(t => t.valor);
        }
      });
    },
    removeTipo(item) {
      const index = this.busca.tiposComissao.indexOf(item.valor);
      if (index >= 0) {
        this.busca.tiposComissao.splice(index, 1);
      }
    },
    toggleTodasFiliais() {
      this.$nextTick(() => {
        if (this.todasFiliaisSelecionadas) {
          this.busca.idfiliais = [];
        } else {
          this.busca.idfiliais = this.filiaisFiltro.map(f => f.idfilial);
        }
      });
    },
    gerarArquivo() {
      if (!this.$refs.form.validate()) {
        return;
      }

      if (this.busca.tiposComissao.length === 0) {
        this.dialogErro.title = "Erro";
        this.dialogErro.msg = "Selecione ao menos um tipo de comissão para exportar!";
        this.dialogErro.icon = "mdi-alert-circle-outline";
        this.dialogErro.iconColor = "red";
        this.dialogErro.status = true;
        return;
      }

      let idfiliais = null;
      if (this.busca.idfiliais.length > 0) {
        idfiliais = this.busca.idfiliais.join(",");
      } else {
        this.dialogErro.title = "Erro";
        this.dialogErro.msg = "Selecione ao menos 1 filial para exportar!";
        this.dialogErro.icon = "mdi-alert-circle-outline";
        this.dialogErro.iconColor = "red";
        this.dialogErro.status = true;
        return;
      }

      this.dados = [];
      this.dialog = true;

      return axios
          .post(`${this.backendUrl}dp/arquivo`, {
            ano: this.busca.dtmes.split("-")[0],
            mes: this.busca.dtmes.split("-")[1],
            idfilial: idfiliais || null,
            tiposComissao: this.busca.tiposComissao,
            responseType: "blob",
          })
          .then((res) => {
            this.dialog = false;

            if (JSON.stringify(res.data) != "{}") {
              if (res.data.valores) {
                this.dados = res.data.valores;
              }

              const url = window.URL.createObjectURL(this.base64ToBlob(res.data.arquivo));
              const link = document.createElement("a");
              link.href = url;
              const dataFormatada = this.busca.dtmes.replace("-", "_");
              link.setAttribute("download", `comissoes_${dataFormatada}.txt`);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              window.URL.revokeObjectURL(url);
            } else {
              this.snackbar.status = true;
            }
          })
          .catch((error) => {
            this.dialog = false;
            this.dialogErro.title = "Erro ao processar";
            this.dialogErro.msg = error.response?.data?.message || "Ocorreu um erro ao gerar o arquivo. Tente novamente.";
            this.dialogErro.icon = "mdi-alert-circle-outline";
            this.dialogErro.iconColor = "red";
            this.dialogErro.status = true;
          });
    },
    base64ToBlob(base64) {
      const decodedData = window.atob(base64);
      const uInt8Array = new Uint8Array(decodedData.length);
      for (let i = 0; i < decodedData.length; ++i) {
        uInt8Array[i] = decodedData.charCodeAt(i);
      }
      return new Blob([uInt8Array], { type: "text/plain" });
    },
    removeFilial(item) {
      const index = this.busca.idfiliais.indexOf(item.idfilial);
      if (index >= 0) {
        this.busca.idfiliais.splice(index, 1);
      }
    },
    getBonificacaoVenda(vendedor, codigo) {
      if (!vendedor.bonificacoes || !vendedor.bonificacoes[codigo]) {
        return 0;
      }
      return vendedor.bonificacoes[codigo].vendatotal || 0;
    },
    getBonificacaoComissao(vendedor, codigo) {
      if (!vendedor.bonificacoes || !vendedor.bonificacoes[codigo]) {
        return 0;
      }
      return vendedor.bonificacoes[codigo].comissao || 0;
    },
    getBonificacaoInfo(codigo) {
      for (let vendedor of this.dadosVendedores) {
        if (vendedor.bonificacoes && vendedor.bonificacoes[codigo]) {
          return {
            nome: vendedor.bonificacoes[codigo].nome || "Bonificação",
            percentual: vendedor.bonificacoes[codigo].percentual || 0,
            eventosenior: vendedor.bonificacoes[codigo].eventosenior || codigo,
          };
        }
      }
      return {
        nome: "Bonificação " + codigo,
        percentual: 0,
        eventosenior: codigo,
      };
    },
    somarCampo(dados, campo) {
      return dados
          .filter((v) => v[campo] !== undefined)
          .map((v) => v[campo])
          .reduce((a, v) => a + v, 0);
    },
    somarBonificacaoVenda(dados, codigo) {
      return dados.reduce((total, vendedor) => {
        if (vendedor.bonificacoes && vendedor.bonificacoes[codigo]) {
          return total + (vendedor.bonificacoes[codigo].vendatotal || 0);
        }
        return total;
      }, 0);
    },
    somarBonificacaoComissao(dados, codigo) {
      return dados.reduce((total, vendedor) => {
        if (vendedor.bonificacoes && vendedor.bonificacoes[codigo]) {
          return total + (vendedor.bonificacoes[codigo].comissao || 0);
        }
        return total;
      }, 0);
    },
    handleExportSuccess(message) {
      this.snackbarSucesso.message = message;
      this.snackbarSucesso.status = true;
    },
    handleExportError(message) {
      this.snackbarErro.message = message;
      this.snackbarErro.status = true;
    }
  },
  created() {},
};
</script>

<style scoped>
tbody tr:hover {
  background-color: rgba(0, 0, 0, 0.02);
}

.v-tooltip__content {
  background-color: rgba(4, 32, 61, 0.99) !important;
  border-radius: 8px;
}

.v-tab {
  text-transform: none !important;
  letter-spacing: normal;
}
</style>